import { defineMessages } from "@/i18n";
import en from "./en";

export const framesChatMessages = defineMessages("frames-chat", en);
